/**
 * nzg-limited-edition.js
 *
 * Blendet die Limited-Edition-Highlight-Box auf der Produktseite ein bzw. aus,
 * wenn der Nutzer die Variante wechselt.
 *
 * Das Theme feuert "variant:change" auf dem <form> (bubbles: true) mit
 * event.detail.variant. Dieses Varianten-Objekt enthaelt KEINE Metafelder,
 * deshalb kommen die Auflagenhoehen aus data-editions, das nzg-limited-edition.liquid
 * server-seitig gerendert hat: { "<variant_id>": <auflage>, ... }
 *
 * Der neue Blocktyp steht nicht in der Rerender-Whitelist von theme.js
 * (ProductRerender -> blockTypes), wird also nicht automatisch server-seitig
 * ausgetauscht. Darum dieser eigene Listener - gleiches Muster wie product-meta-line.js.
 *
 * Scoping ueber das umschliessende <safe-sticky>, damit mehrere Produktformulare
 * auf einer Seite (featured product, quick buy) sich nicht gegenseitig ueberschreiben.
 */

document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant) return;

  const container = event.target.closest('safe-sticky');
  if (!container) return;

  const box = container.querySelector('.nzg-limited-edition');
  if (!box) return;

  updateLimitedEdition(box, variant);
});

function updateLimitedEdition(box, variant) {
  let editions;

  try {
    editions = JSON.parse(box.dataset.editions || '{}');
  } catch {
    return;
  }

  const editionSize = editions[String(variant.id)];

  // Variante ist nicht limitiert -> Box komplett ausblenden
  if (!editionSize) {
    box.hidden = true;
    return;
  }

  const notice = box.querySelector('[data-le-notice]');
  if (notice) {
    notice.textContent = (box.dataset.textNotice || '').replace('__SIZE__', editionSize);
  }

  box.hidden = false;
}
